// ファイル関連の型定義

export interface UploadedFile {
  id: string;
  file: File;
  status: 'pending' | 'uploading' | 'completed' | 'error';
  progress?: number;
  error?: string;
}

export interface FileUploadResponse {
  success: boolean;
  fileId: string;
  message?: string;
  error?: string;
}

export interface FileValidationError {
  type: 'size' | 'format' | 'content' | 'duplicate' | 'count' | 'unknown';
  message: string;
  fileName: string;
}

export interface FileUploadConfig {
  maxFileSize: number; // bytes
  allowedTypes: string[];
  maxFiles: number;
}

export const DEFAULT_FILE_CONFIG: FileUploadConfig = {
  maxFileSize: 10 * 1024 * 1024, // 10MB
  allowedTypes: [
    'application/pdf',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/csv',
    'image/jpeg',
    'image/png',
    'image/jpg'
  ],
  maxFiles: 10
};

export type FileType = 'pdf' | 'excel' | 'word' | 'ppt' | 'csv' | 'image' | 'other';

export interface FileTypeInfo {
  type: FileType;
  icon: string;
  color: string;
}
